import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["element-loading-text"]

import { ref, onMounted, reactive, unref } from 'vue'

/* Npm Plugins */
import { FormRules, ElMessage, ElForm } from 'element-plus'

/* Components */
import { GbDialog } from '@/components/GbDialog/Index'

/* Hooks & Utils & Stores */
import { useLocales } from '@/hooks/useLocales'

/* Apis */
import { GetCompanyDpListApi } from '@/apis/basics/companys/apis'
import { GetDeptCascaderTreeApi, CreateDeptApi, ModifyDeptApi, GetDeptDetailApi } from '@/apis/basics/department/apis'

/* Dtos */
import { DeptDtoBase } from '@/apis/basics/department/dtos'


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const { t } = useLocales()

const elFormRef = ref<ComponentRef<typeof ElForm>>()

const state = reactive({
    show: false,
    loading: false,
    title: '',
    isAsync: false,
    isEditor: false,
    cascaderProps: { label: 'dept_name', value: 'id', expandTrigger: 'hover', checkStrictly: true, emitPath: false },
})

const companyList = ref<any[]>([])
const deptTreeList = ref<any[]>([])

const formSchema = ref<DeptDtoBase>({
    id: '',
    revision: '',
    dept_code: '',
    dept_name: '',
    pid: '',
    company_id: '',
    sort: 0,
    remark: '',
    is_enabled: ''
})

/* 表单验证规则 */
const formRules: FormRules = {
    company_id: [{ required: true, message: t('basics.department.forms.companyId.valitext', "请选择所属公司"), trigger: 'blur' }],
    dept_code: [{ required: true, message: t('basics.department.forms.deptCode.valitext', "部门编号不能为空"), trigger: 'blur' }],
    dept_name: [{ required: true, message: t('basics.department.forms.deptName.valitext', "部门名称不能为空"), trigger: 'blur' }],
}

/* 联级菜单选中 */
const onCompanyChange = async (val: any) => {
    await load.getDeptCascaderTree(val)
}

/* 需要处理加载的数据 */
const load = {
    /* 公司数据选择 */
    getCompanyDpList: async () => {
        const { succeeded, errors, data } = await GetCompanyDpListApi()

        if (!succeeded) {
            ElMessage.error(errors)
        } else {
            companyList.value = data || []
        }
    },

    /* 部门联级选择 */
    getDeptCascaderTree: async (cmpId: string) => {
        const { succeeded, errors, data } = await GetDeptCascaderTreeApi(cmpId)

        if (!succeeded) {
            ElMessage.error(errors)
        } else {
            deptTreeList.value = data || []
        }
    },
}

const expostFuncs = {
    /* 创建 */
    create: () => {
        formSchema.value = Object({
            id: '',
            revision: '0',
            dept_code: '',
            dept_name: '',
            pid: '',
            pids: [],
            company_id: '',
            sort: 1000,
            remark: '',
            is_enabled: 'Y'
        })

        state.title = t('basics.department.title.create', '创建部门')
        state.isEditor = false
        state.show = true
    },

    /* 修改 */
    editor: async (rowId: string) => {
        state.loading = true

        const { succeeded, errors, data } = await GetDeptDetailApi(rowId)

        if (!succeeded) {
            ElMessage.error(errors)
        } else {
            formSchema.value = data
            load.getDeptCascaderTree(data.company_id)
        }

        state.title = t('basics.department.title.editor', "编辑部门")
        state.loading = false
        state.isEditor = true
        state.show = true
    },
}

/* 点击保存按钮 */
const onSaveBtnClick = () => {
    unref(elFormRef)?.validate(async (valid: boolean) => {
        if (!valid) return

        state.loading = true

        const formData = unref(formSchema)
        formData.pid = !formData.pid ? "" : formData.pid

        const api = !state.isEditor ? CreateDeptApi : ModifyDeptApi
        const { succeeded, errors } = await api(formData)

        state.loading = false

        if (!succeeded) {
            ElMessage.error(errors)
        } else {
            ElMessage.success(t('tips.savesuccess'))
            state.show = false
        }

        $emits('refresh')
    })
}

expose({ ...expostFuncs })

onMounted(() => {
    load.getDeptCascaderTree('')
    // load.getCompanyDpList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).title,
    style: {"width":"640px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        disabled: _unref(state).loading,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        disabled: _unref(state).loading,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.closed')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        "element-loading-text": _unref(t)('tips.submiting')
      }, [
        _createVNode(_unref(ElForm), {
          size: "small",
          ref_key: "elFormRef",
          ref: elFormRef,
          "label-width": "100px",
          model: formSchema.value,
          "label-position": 'right',
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.department.forms.deptCode.label', '部门编号'),
                      prop: "dept_code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.dept_code,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.dept_code) = $event)),
                          disabled: _unref(state).isAsync
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.department.forms.deptName.label', '部门名称'),
                      prop: "dept_name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.dept_name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.dept_name) = $event)),
                          disabled: _unref(state).isAsync
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                (formSchema.value.pid != '10000000-0000-0000-0000-000000000001')
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('basics.department.forms.parentId.label', '上级部门'),
                          prop: "pid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_cascader, {
                              modelValue: formSchema.value.pid,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.pid) = $event)),
                              props: _unref(state).cascaderProps,
                              options: deptTreeList.value,
                              clearable: "",
                              filterable: "",
                              style: {"width":"100%"},
                              placeholder: _unref(t)('basics.department.forms.parentId.placeholder', '若不选则或没有选择数据，则为根节点部门')
                            }, null, 8, ["modelValue", "props", "options", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.department.forms.remark.label', '备注'),
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.remark,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.remark) = $event)),
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "200",
                          rows: "4",
                          placeholder: _unref(t)('basics.department.forms.remark.placeholder', '请输入备注')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.department.forms.sort.label', '排序')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formSchema.value.sort,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.sort) = $event)),
                          step: "100",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.department.forms.is_enabled.label', '状态')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_enabled,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('basics.department.options.enabled', '启用')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('basics.department.options.disabled', '停用')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ], 8, _hoisted_1)), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})